var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#94BE43"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24.8889L19.3846 32L36 16",
    stroke: "white",
    strokeWidth: 2.07692
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreation);
export default __webpack_public_path__ + "static/media/creation.1e61b3f482b6d19db789974a1437ea6c.svg";
export { ForwardRef as ReactComponent };